import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import clsx from 'clsx'

export const LanguageSwitcher = ({
    handleToggleMenu,
    color = 'navy',
    fontSize = 'sm'
}: {
    handleToggleMenu?: () => void
    color?: string
    fontSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}) => {
    const { i18n } = useTranslation()
    const router = useRouter()

    const changeLanguage = (lng: string) => {
        handleToggleMenu && handleToggleMenu()
        i18n.changeLanguage(lng)
        router.push(router.asPath, undefined, { locale: lng })
    }

    const styles = {
        button: clsx(
            `tracking-v-xs relative hover:opacity-50 duration-[150ms] after:content-[''] after:block after:w-0 after:h-[1px] after:bg-v-${color} after:duration-[200ms]`
        ),
        active: clsx(`opacity-50 cursor-not-allowed`),
        inactive: clsx(`opacity-100 hover:after:w-full`)
    }

    return (
        <ul className={`flex gap-4 md:justify-end text-v-${color}`}>
            <li
                className={clsx(
                    `text-v-${fontSize} tracking-v-xl`,
                    "after:content-['/'] after:ml-4"
                )}
            >
                <button
                    onClick={() => changeLanguage('en')}
                    className={clsx(
                        styles.button,
                        i18n.language === 'en' ? styles.active : styles.inactive
                    )}
                >
                    English
                </button>
            </li>
            <li className={`text-v-${fontSize}`}>
                <button
                    onClick={() => changeLanguage('ja')}
                    className={clsx(
                        styles.button,
                        i18n.language === 'ja' ? styles.active : styles.inactive
                    )}
                >
                    日本語
                </button>
            </li>
        </ul>
    )
}
